import { loadingBarModule } from '../vendor/loading-bar-module';

export const loadingBarConfigModule = angular
  .module('Q.config.loading-bar', [loadingBarModule])

  /**
   * Overrides the default loading bar interceptor during a route change for
   * a smoother loading animation
   */
  .factory(
    'loadingBarRouteHandlerInterceptor',
    function loadingBarRouteHandlerInterceptor(
      $rootScope,
      $timeout,
      cfpLoadingBar,
    ) {
      // Used to track when we are overriding the default loading bar, so we can prevent it
      let isLoadingRoute = false;

      // always delay the loading bar a bit, so we don't show it on quick route changes
      let starterTimeout = null;

      // Automatically ignore any state without resolves, or if a state has explicitly requested that
      // the default behavior is preserved.
      function ignoreState(state) {
        return (
          !state ||
          !state.resolve ||
          (state.data && state.data.defaultLoadingBar)
        );
      }

      $rootScope.$on('$stateChangeStart', function (event, toState) {
        if (ignoreState(toState)) return;

        isLoadingRoute = true;
        starterTimeout = $timeout(() => {
          cfpLoadingBar.start();
          starterTimeout = null;
        }, 100);
      });

      function complete(event, toState) {
        if (ignoreState(toState)) return;

        isLoadingRoute = false;
        if (starterTimeout) {
          $timeout.cancel(starterTimeout);
          starterTimeout = null;
        }
        cfpLoadingBar.complete();
      }

      $rootScope.$on('$stateChangeSuccess', complete);
      $rootScope.$on('$stateChangeError', complete);

      return {
        request(config) {
          if (isLoadingRoute) {
            config.ignoreLoadingBar = true;
          }
          return config;
        },
      };
    },
  )

  .config(function (cfpLoadingBarProvider, $httpProvider) {
    // make sure our route handler interceptor is first
    $httpProvider.interceptors.unshift('loadingBarRouteHandlerInterceptor');

    cfpLoadingBarProvider.includeSpinner = false;
  });
